import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/AppDownloadPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/StoreBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/TestimonialCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next/dist/client/link.js");
